import React, {Fragment} from "react";
import {
    getDataFormattata,
} from "../../../../../utility/common";
import NsDataTable from "../../../../../components/tabelle/NsDataTable";
import ModalConfirm from "../../../../../components/ModalConfirm";

export default function DocFirmatoView({
                                           documento,
                                           isRuoloAdmin,
                                           isRuoloSegreteria,
                                           downloadDocumento,
                                           eliminaDocumento,
                                           show,
                                           showConfirmEliminaDocumento,
                                           hideConfirmEliminaDocumento,
                                       }) {

    return (
        <Fragment>
            <h2>Visualizza documento firmato</h2>
            <ModalConfirm
                show={show}
                handleClose={hideConfirmEliminaDocumento}
                handleOk={eliminaDocumento}
                testo={`Sicuro di voler eliminare il documento firmato: ${documento && documento.nome_file_originale}?`}/>
            <NsDataTable
                data={[documento]}
                columns={[
                    {
                        name: 'Nome file',
                        selector: row => row.nome_file_originale,
                        sortable: true,
                    },
                    {
                        name: 'Utente inserimento',
                        selector: row => row.usr_ins,
                        sortable: true,
                    },
                    {
                        name: 'Data inserimento',
                        selector: row => getDataFormattata(row.data_ins),
                        sortable: true,
                    },
                    {
                        name: '',
                        selector: row =>
                            <Fragment>
                                <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                    <div className="btn-group" role="group">
                                        <button id="btnGroupDrop1" type="button"
                                                className="btn btn-dark dropdown-toggle"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="fa-solid fa-bars"></i>
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                            <li>
                                                <button className="dropdown-item"
                                                        data-toggle="tooltip" title="Download" onClick={() => {
                                                    downloadDocumento(row, true)
                                                }}>
                                                    <i className="fas fa-download"/> Scarica
                                                </button>
                                            </li>
                                            <li>
                                                <button className="dropdown-item"
                                                        data-toggle="tooltip" title="Visualizza" onClick={() => {
                                                    downloadDocumento(row, false)
                                                }}>
                                                    <i className="fas fa-eye"/> Visualizza
                                                </button>
                                            </li>
                                            {
                                                documento && (isRuoloAdmin() || isRuoloSegreteria()) &&
                                                <li>
                                                    <button className="dropdown-item"
                                                            data-toggle="tooltip" title="Elimina"
                                                            onClick={showConfirmEliminaDocumento}
                                                    >
                                                        <i className="fas fa-trash"/> Elimina
                                                    </button>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </Fragment>,
                        sortable: false,
                        right: true,
                    }
                ]}
                addPagination={false}
                addFiltri={false}
            />
        </Fragment>
    );

}